module.exports = __webpack_public_path__ + "static/media/wittledefender_logo_en@2x.d430ede5.png";